import SparkMD5 from "spark-md5"
import _ from "lodash"

export function isEmptyObject(obj) {
  if (obj === null) return true
  return Object.keys(obj).length === 0
}

export function isEmpty(value) {
  if (value === undefined || value === null) return true
  if (value instanceof Object && JSON.stringify(value) == "{}") return true
  if ((value + "").replace(/(^\s*)|(\s*$)/g, "").length === 0) return true
  return false
}

// 深拷贝对象
export function deepClone(obj) {
  return _.cloneDeep(obj)
}

// 将嵌套对象转成一层对象
export function flatObject(obj) {
  let outObj = {}
  function recursiveObj(obj, nowKey = "") {
    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (obj[key] && Object.prototype.toString.call(obj[key]) == "[object Object]") {
          if (Object.keys(obj[key]) != 0) recursiveObj(obj[key], nowKey ? nowKey + "__" + key : key)
        } else {
          let type = Object.prototype.toString.call(obj[key])
          type = type.slice(8, type.length - 1)
          if (nowKey) outObj[nowKey + "__" + key] = type
          else outObj[key] = type
        }
      }
    }
  }
  recursiveObj(obj)
  return outObj
}

// “深冻结”对象
export function deepFreeze(obj) {
  if (Array.isArray(obj)) {
    for (let item of obj) {
      if (typeof item === "object") {
        item = deepFreeze(item)
      }
    }
  } else {
    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && typeof obj[key] === "object") {
        obj[key] = deepFreeze(obj[key])
      }
    }
  }
  typeof obj === "object" && (obj = Object.freeze(obj))
  return obj
}
/**
 * 生成随机字符串
 * @param {Number} length
 */
// 生成随机字符串
export function randomString(length) {
  let result = ""
  let chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".split("")
  for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))]
  return result
}

// 下载 Blob
export function downloadBlob(blob, filename) {
  if ("download" in document.createElement("a")) {
    const downloadElement = document.createElement("a")
    let href = ""
    if (window.URL) href = window.URL.createObjectURL(blob)
    else href = window.webkitURL.createObjectURL(blob)
    downloadElement.href = href
    downloadElement.download = filename
    document.body.appendChild(downloadElement)
    downloadElement.click()
    if (window.URL) window.URL.revokeObjectURL(href)
    else window.webkitURL.revokeObjectURL(href)
    document.body.removeChild(downloadElement)
  } else {
    navigator.msSaveBlob(blob, filename)
  }
}

// 正则校验网址
export function verifyUrl(url) {
  // eslint-disable-next-line no-useless-escape
  let reg = /^(((ht|f)tps?):\/\/)?[\w\-]+(\.[\w\-]+)+([\w\-.,@?^=%&:\/~+#]*[\w\-@?^=%&\/~+#])?$/
  return reg.test(url)
}

// 复制至剪切板
export function copyToClipBoard(text) {
  const dom = document.createElement("input")
  dom.value = text
  document.body.appendChild(dom)
  dom.select()
  document.execCommand("copy")
  document.body.removeChild(dom)
}

// 分解文件名和扩展名
export function resolveFileName(filename) {
  let lastSpot = filename.lastIndexOf(".")
  let ext = "",
    name = ""
  // 可以找到 “.”，且不是最后一个字符
  if (lastSpot != -1 && lastSpot != filename.length - 1) {
    ext = filename.slice(lastSpot + 1).toLowerCase()
    name = filename.slice(0, lastSpot)
  } else {
    name = filename
  }
  return { name, ext }
}

// 获取文件的大小
export function getFileSizeStr(fileBytes) {
  let level = 0
  let units = ["B", "KB", "MB", "GB", "TB"]
  while (fileBytes > 1024) {
    fileBytes = fileBytes / 1024
    level++
  }
  return fileBytes.toFixed(2) + units[level]
}

// 校验文件名是否正确
export function checkFileName(filename) {
  let reg = /[\\\\/:*?"<>|]/
  return !reg.test(filename)
}

// 获取文件的 hash 值
export function getFileHash(file) {
  return new Promise((resolve, reject) => {
    let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
      chunkSize = 2097152, // Read in chunks of 2MB
      chunks = Math.ceil(file.size / chunkSize),
      currentChunk = 0,
      spark = new SparkMD5.ArrayBuffer(),
      fileReader = new FileReader()

    fileReader.onload = function(e) {
      spark.append(e.target.result) // Append array buffer
      currentChunk++

      if (currentChunk < chunks) {
        loadNext()
      } else {
        return resolve(spark.end())
      }
    }

    fileReader.onerror = function() {
      console.warn("oops, something went wrong.")
      return reject("文件读取错误")
    }

    function loadNext() {
      let start = currentChunk * chunkSize,
        end = start + chunkSize >= file.size ? file.size : start + chunkSize

      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
    }

    loadNext()
  })
}

// 处理 OTA 文件(校验OTA文件后16位的hash值，是否与hash值前面的文件的hash相等)
export function handleOTAFile(file) {
  if (file.size <= 16) return Promise.reject({ result: false })
  let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
  let newFile = new File([blobSlice.call(file, 0, -16)], file.name, {
    type: file.type
  })
  newFile.uid = file.uid // 上传oss时用到
  return getFileHash(newFile).then(hash => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader()
      reader.readAsArrayBuffer(blobSlice.call(file, -16))
      reader.onload = function(e) {
        let arr = new Uint8Array(e.target.result),
          str = ""
        for (var i = 0; i < arr.length; ++i) {
          str += arr[i].toString(16).padStart(2, "0")
        }
        if (hash == str) newFile.hash = hash
        return resolve({
          result: hash == str,
          file: newFile
        })
      }
    })
  })
}

/**
 * @param {string} url
 * @returns {Object}
 */
// url 参数转为对象
export function param2Obj(url) {
  const search = url.split("?")[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, " ") +
      '"}'
  )
}

export function objects2object(objects, ...properties) {
  if (properties.length === 1) {
    let val = _.map(objects, properties[0])
    if (val.length === 1) return val[0]
    return val
  }
  return _.chain(objects)
    .groupBy(properties[0])
    .mapValues(function(val) {
      return objects2object(val, ...properties.slice(1))
    })
    .value()
}

export function object2objects(object, ...properties) {
  let name = properties[0]
  if (!_.isObject(object)) {
    let res = {}
    res[name] = object
    return [res]
  }
  let res = []
  _.keys(object).forEach(function(key) {
    let sons = object2objects(object[key], ...properties.slice(1)).map(son => {
      son[name] = key
      return son
    })
    res = res.concat(sons)
  })
  return res
}

/**
 * 获取 val 的变量类型
 * @param {any} val
 */
export function getVarType(val) {
  return Object.prototype.toString.call(val).match(/\[object (\S*)\]/)[1]
}

/**
 * 判断 obj 是否有 key 这一属性
 * @param {Object} obj
 * @param {String} key
 */
export function hasOwnProperty(obj, key) {
  if (typeof obj !== "object") return false
  return Object.prototype.hasOwnProperty.call(obj, key)
}

/**
 * 获取两个对象不同的属性
 * @param {Object} objA
 * @param {Object} objB
 */
export function getDiffProps(objA, objB) {
  let diff = []
  for (let cid in objA) {
    if (!_.isEqual(objA[cid], objB[cid])) {
      diff.push(cid)
    }
  }
  return diff
}

/**
 * 计算字符串长度(英文占1个字符，中文汉字占2个字符)
 * @param str
 * @returns {number}
 */
export function strLen(str) {
  let len = 0
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
      len += 2
    } else {
      len++
    }
  }
  return len
}

export function getFileType(type) {
  if (type.startsWith("image/")) {
    return "img"
  }
  switch (type) {
    case "doc":
    case "docx":
      return "word"
    case "xls":
    case "xlsx":
      return "excel"
    case "ppt":
    case "pptx":
      return "ppt"
    case "pdf":
      return "pdf"
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
    case "webp":
      return "img"
  }
  return null
}

/**
 * 将base64转成File
 * @param base64
 * @param name
 * @param type
 * @param lastModified
 * @returns {File}
 */
export function base64ToFile(base64, name, type, lastModified) {
  let byteString = atob(base64)
  let ab = new ArrayBuffer(byteString.length)
  let ia = new Uint8Array(ab)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new File([ia], name, { type: type, lastModified: lastModified })
}

export function makeFileName(file) {
  let { ext } = resolveFileName(file.name)
  return file.uid + "_" + randomString(8) + "." + ext
}

export function mergeSet(s1, s2) {
  return new Set([...s1, ...s2])
}

export function isValidObjectId(str) {
  return /^(\d|[a-z]){24}$/.test(str)
}

function escapeRegExp(string) {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&") // $& means the whole matched string
}

/**
 * 替换字符串
 * @param str
 * @param find
 * @param replace
 * @returns {*}
 */
export function replaceAll(str, find, replace) {
  return str.replace(new RegExp(escapeRegExp(find), "g"), replace)
}

export function getCompressedUrl(imgUrl) {
  return /https:\/\/(new-service|static-legacy\.dingtalk\.com)/.test(imgUrl)
    ? imgUrl + "?x-oss-process=image/resize,l_50,m_lfit"
    : null
}

export function addToMap(map, key, val) {
  if (!key) return
  if (map[key]) map[key].push(val)
  else map[key] = [val]
}

export function object2Str(o) {
  if (_.isObject(o) && o.id) return o.id
  if (_.isString(o) && o) return o
  return null
}

export function getIdList(arr) {
  return (arr || []).map(object2Str).filter(t => t)
}

export function stringIncludes(str, keyword, { ignoreCase = true } = {}) {
  if (ignoreCase) {
    return str?.toLowerCase().includes(keyword.toLowerCase())
  }
  return str?.includes(keyword)
}

export function getDealData(yAxisFormat, data, showThousands = false) {
  if ([undefined, null, "NaN", NaN].includes(data)) return null
  let result = data
  switch (yAxisFormat) {
    case "AUTO":
      result = showThousands ? numFormat(data) : data
      break
    case "INTEGER":
      result = showThousands ? numFormat(Math.round(data)) : Math.round(data)
      break
    case "ONE_DECIMAL":
      result = showThousands ? numFormat(data.toFixed(1)) : data.toFixed(1)
      break
    case "TWO_DECIMAL":
      result = showThousands ? numFormat(data.toFixed(2)) : data.toFixed(2)
      break
    case "THREE_DECIMAL":
      result = showThousands ? numFormat(data.toFixed(3)) : data.toFixed(3)
      break
    case "FOUR_DECIMAL":
      result = showThousands ? numFormat(data.toFixed(4)) : data.toFixed(4)
      break
    case "PERCENT":
      result = (showThousands ? numFormat(data * 100) : data * 100) + "%"
      break
    case "PERCENT_ONE":
      result = (showThousands ? numFormat((data * 100).toFixed(1)) : (data * 100).toFixed(1)) + "%"
      break
    case "PERCENT_TWO":
      result = (showThousands ? numFormat((data * 100).toFixed(2)) : (data * 100)?.toFixed(2)) + "%"
      break
    case "PERCENT_THREE":
      result = (showThousands ? numFormat((data * 100).toFixed(3)) : (data * 100)?.toFixed(3)) + "%"
      break
    case "PERCENT_FOUR":
      result = (showThousands ? numFormat((data * 100).toFixed(4)) : (data * 100)?.toFixed(4)) + "%"
      break
  }
  return result
}

// 获取千分位函数(保留小数)
function numFormat(num) {
  const res = num.toString().replace(/\d+/, function(n) {
    return n.replace(/(\d)(?=(\d{3})+$)/g, function($1) {
      return $1 + ","
    })
  })
  return res
}

export function getDateExpression(unit, value) {
  let result = ""
  if (value < 0) {
    result = " - " + -value + unit
  }
  if (value > 0) {
    result = " + " + value + unit
  }
  return result
}

export function isObject(data) {
  let isObject = false
  try {
    let obj = JSON.parse(data)
    isObject = !!(typeof obj === "object" && obj)
  } catch (e) {
    isObject = false
  }
  return isObject
}
